module.exports = __webpack_public_path__ + "static/media/bahawalpur.2521f25c.svg";